<i class="far {{faIconClass}}" [style.font-size]="size" [style.color]="color"></i>